export default "__VITE_ASSET__Cx7chwht__";